/**
 * Transform an AI reply into a clean, speakable string.
 * - Strips URLs (and the entire citation line) and replaces with a localized
 *   "for more info, click this link" phrase if a URL was present.
 * - Removes emojis, markdown markers, bullet glyphs and other characters that
 *   TTS engines tend to mispronounce.
 * - Leaves natural punctuation (. , ? ! :) so the voice still has rhythm.
 */
const LINK_PHRASE = {
  tr: "Detaylı bilgi için sayfadaki bağlantıya tıklayabilirsiniz.",
  en: "You can click the link on the page for more details.",
  ar: "يمكنك النقر على الرابط الموجود في الصفحة لمزيد من التفاصيل.",
  ru: "Подробнее можно узнать по ссылке на странице.",
};

export function makeSpeakable(text, lang = "tr") {
  if (!text) return "";
  let s = text;

  // Detect if the message contains any URL (citation)
  const hasUrl = /https?:\/\/\S+/.test(s);

  // Remove the whole citation line including emoji + label + URL
  s = s.replace(/[📖🔗ℹ️]\s*[^\n]*?https?:\/\/\S+/g, "");
  // Remove any standalone URLs that may remain
  s = s.replace(/https?:\/\/\S+/g, "");

  // Strip emojis (broad unicode ranges) and decorative glyphs
  s = s.replace(/[\u{1F300}-\u{1FAFF}\u{2600}-\u{27BF}\u{1F000}-\u{1F0FF}]/gu, "");
  s = s.replace(/[•●◦▪▫■□★☆➤➜→←↔]/g, "");

  // Strip markdown formatting characters
  s = s.replace(/[*_`#~]+/g, "");
  // Remove leftover brackets/parentheses around now-empty content
  s = s.replace(/\(\s*\)|\[\s*\]/g, "");
  // Collapse repeated punctuation like "..." or ", ," into single
  s = s.replace(/([.,;:!?])\1+/g, "$1");
  // Collapse consecutive whitespace and newlines
  s = s.replace(/\s+/g, " ").trim();
  // Remove dangling punctuation at the end if any after cleaning
  s = s.replace(/[\s.,;:]+$/g, "").trim();

  if (hasUrl) {
    s = `${s} ${LINK_PHRASE[lang] || LINK_PHRASE.tr}`;
  }
  return s;
}
